<template>

    <li :class="{'nav-item':true, 'dropdown':menulink.children.length > 0}">
        <inertia-link
            :class="{'nav-link':true, 'active': isActive}"
            :href="menulink.route"
            @click="$emit('menuLinkClicked')"
            v-html="menulink.name"
        />
        <ul
            v-if="menulink.children.length > 0"
            class="dropdown-menu"
        >
            <shared-menu-link
                v-for="ml in menulink.children"
                :menulink="ml"
                :key="'menulink-' + ml.route"
                @menuLinkClicked="$emit('menuLinkClicked')"
            ></shared-menu-link>
        </ul>
    </li>

</template>

<script>

export default {

    computed: {
        isActive() {
            let basehost = location.protocol + '//' + location.host + '/';

            if (this.menulink.route + '/' === basehost) {
                return location.href === basehost;
            }

            if (this.menulink.exactMatch === true) {
                return this.menulink.route === location.href;
            }

            return this.menulink.route === location.href ||
                (
                    this.menulink.route !== basehost &&
                    location.href.substr(0, this.menulink.route.length) === this.menulink.route
                );
        },
    },

    name:'shared-menu-link',

    props: {
        menulink: {
            required:true,
            type:Object,
        },
    },

}

</script>
